import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Divider from '@material-ui/core/Divider';

import intlEquipped, { propTypes as i18nPropTypes } from '../../../hocs/intlEquipped';
import { invoiceStatusKeys } from '../../../constants/invoiceStatusKeys';
import { invoicePropType } from '../../../types/invoice';

import { isPaymentTypeCreditCard } from '../../SapiSubscriptionModule/utils/helpers';
import InlineSection from '../../InlineSection/InlineSection';
import PaymentIcon from '../../PaymentIcon';
import { invoiceStatuses } from '../../../constants/statuses';
import { getPaymentIconSrc } from '../../../util/getPaymentIconSrc';

const PaymentDetails = ({ invoice, theme, i18n }) => {
    const { status, payment = {}, total = {}, customerData = {} } = invoice;
    const { formatMessage } = i18n;
    const isCreditCard = isPaymentTypeCreditCard({ payment });

    const street = customerData?.invoiceAddress?.street;
    const locality = customerData?.invoiceAddress?.locality;
    const postalCode = customerData?.invoiceAddress?.postalCode;
    const firstName = customerData?.firstName || '';
    const lastName = customerData?.lastName || '';

    const showPaidBy = firstName && lastName;
    const showToBeCharged = status === invoiceStatuses.TO_BE_CHARGED && total.amount > 0;
    const showPaymentStatus = status && (status !== invoiceStatuses.TO_BE_CHARGED || showToBeCharged);
    const paymentIconSrc = getPaymentIconSrc(payment.paymentIconType);

    return (
        <>
            {showPaymentStatus && (
                <>
                    <Divider className={ theme.divider } />
                    <InlineSection
                        theme={ theme }
                        mainContent={
                            <span>{ formatMessage('invoices.payment.status') }</span>
                        }
                        subContent={
                            <span className={ theme.status }>{ formatMessage(invoiceStatusKeys[status]) }</span>
                        }
                    />
                </>
            )}
            {showPaidBy && (
                <>
                    <Divider className={ theme.divider } />
                    <InlineSection
                        theme={ theme }
                        mainContent={
                            <span>{ formatMessage('invoices.payment.paidBy') }</span>
                        }
                        subContent={ (
                            <div className={ theme.address }>
                                <span className={ theme.name }>{ `${firstName} ${lastName}` }</span>
                                <span>{ street }</span>
                                <span>
                                    { postalCode && `${postalCode} ` }
                                    { locality }
                                </span>
                            </div>
                        ) }
                    />
                </>
            )}
            {!!paymentIconSrc && (
                <>
                    <Divider className={ theme.divider } />
                    <InlineSection
                        theme={ theme }
                        mainContent={
                            <span>{ formatMessage('invoices.payment.paidWith') }</span>
                        }
                        subContent={ (
                            <>
                                {payment.paymentDetail && (
                                    <span className={ classnames({
                                        [theme.creditCard]: isCreditCard,
                                        [theme.paymentDetail]: true,
                                    }) }
                                    >
                                        {payment.paymentDetail}
                                    </span>
                                )}
                                <PaymentIcon
                                    iconSrc={ paymentIconSrc }
                                    alt={ payment.paymentIconType }
                                    theme={ theme }
                                />
                            </>
                        ) }
                    />
                </>
            )}
            <Divider className={ theme.divider } />
        </>
    );
};

PaymentDetails.propTypes = {
    invoice: invoicePropType,
    theme: PropTypes.shape({}),
    i18n: i18nPropTypes,
};

export default intlEquipped(PaymentDetails);
